import { Icon } from "@iconify/vue";
import { createApp } from "vue";

import App from "./App.vue";
import { useTheme } from "./composables/useTheme";
import { router } from "./router";

import "./styles.css";

useTheme();

const app = createApp(App).component("Icon", Icon).use(router);
app.mount("#app");
